import { EMPTY_VALUE } from '../../constants';
import { acceptObjectValue } from '../../field-viewer/shared-normalizers';
export function acceptFullNameValue(args) {
    const result = acceptObjectValue(args);
    return result === EMPTY_VALUE ? {} : result;
}

//# sourceMappingURL=full-name-normalize-value.js.map